import { render, staticRenderFns } from "./RightClickMenu.vue?vue&type=template&id=dee546b6&scoped=true"
import script from "./RightClickMenu.vue?vue&type=script&lang=js"
export * from "./RightClickMenu.vue?vue&type=script&lang=js"
import style0 from "./RightClickMenu.vue?vue&type=style&index=0&id=dee546b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee546b6",
  null
  
)

export default component.exports